import { useMutation } from '@tanstack/react-query';
import { publicOptOut } from '../../../services/broadcastService';

interface IOptOutError {
  cause?: number;
  message?: string;
}

export const usePublicOptOut = () => {
  const { mutate, isLoading, isSuccess, isError, error } = useMutation<void, IOptOutError, string>(
    (token: string) => publicOptOut(token)
  );

  return {
    optOut: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
